import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import es from 'vuetify/es5/locale/es'
import Vuetify from 'vuetify/lib'

import { ColoresBlu } from '@/common/constantes'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  icons: {
    // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#253670',
        secondary: '#324A74',
        accent: ColoresBlu.BLU_2,
        error: '#FF5252',
        info: '#1374F2',
        success: '#1F8777',
        warning: '#FFC107',
        disabled: '#D0D0D0',
        weakBlu: '#BBDEF0',
        mediumBlu: '#1374F2',
        strongBlu: '#142660',
        light: ColoresBlu.BLU_2,
        yellowRating: '#F9A831',
        orange: '#FF9D20'
      }
    },
    light: true
  }
})
